import {
    Church, Castle, TreePine, Camera, Baby, Flower2, Trophy, Music, Footprints,
    BookOpen, Flame, PartyPopper, Dumbbell, Monitor, Drama, Utensils, Waves,
    Laptop, DoorOpen, ShieldCheck, Car, Sun, MoveUp, Users, Wind, Droplets,
    Briefcase, Building2, Wifi, Truck, Warehouse, Zap, Scaling, Factory, Ruler, Construction
} from 'lucide-react';

export const AMENITIES_LIST = [
    // --- Residential & General ---
    { name: 'Temple / Prayer Hall', icon: Church },
    { name: 'Designer Clubhouse', icon: Castle },
    { name: 'Landscape Garden', icon: TreePine },
    { name: 'CCTV Surveillance', icon: Camera },
    { name: 'Indoor & Outdoor Kids Area', icon: Baby },
    { name: 'Yoga & Meditation Deck', icon: Flower2 },
    { name: 'Squash & Badminton Court', icon: Trophy },
    { name: 'Discotheque', icon: Music },
    { name: 'Trampoline Den', icon: Footprints },
    { name: 'Library', icon: BookOpen },
    { name: 'Karaoke Room', icon: Music },
    { name: 'Campfire Area', icon: Flame },
    { name: 'Banquet Hall', icon: PartyPopper },
    { name: 'Dance Room', icon: Music },
    { name: 'Gymnasium & Cross-fit', icon: Dumbbell },
    { name: 'Recliner Cinema', icon: Monitor },
    { name: 'Kids Theater', icon: Drama },
    { name: 'Cafeteria', icon: Utensils },
    { name: 'Spa, Massage, Jacuzzi', icon: Waves },
    { name: 'Box Cricket', icon: Trophy },
    { name: 'Indoor Game Zone', icon: Trophy },
    { name: 'Outdoor Workstation', icon: Laptop },
    { name: 'Swimming Pool', icon: Waves },
    { name: 'Gated Entrance', icon: DoorOpen },
    { name: 'Security Cabin', icon: ShieldCheck },
    { name: 'Allotted Parking', icon: Car },
    { name: 'Solar Panel', icon: Sun },
    { name: 'Fire Safety', icon: Flame },
    { name: 'High Speed Lift', icon: MoveUp },
    { name: 'Senior Citizen Sit-out', icon: Users },
    { name: 'Gazebo', icon: Wind },
    { name: 'Rainwater Harvesting', icon: Droplets },
    // --- Commercial Specific ---
    { name: 'Corporate Boardroom', icon: Briefcase },
    { name: 'Business Lounge', icon: Users },
    { name: 'Grand Reception Lobby', icon: Building2 },
    { name: 'High-Speed Wi-Fi', icon: Wifi },
    { name: 'Valet Parking', icon: Car },
    { name: 'Smoke Detectors', icon: Flame },
    // --- Industrial Specific ---
    { name: 'Loading/Unloading Bay', icon: Warehouse },
    { name: 'Heavy Vehicle Parking', icon: Truck },
    { name: '24/7 Power Backup', icon: Zap },
    { name: 'High Ceiling Clearance', icon: Scaling },
    { name: 'Labor Quarters', icon: Factory },
    { name: 'Weigh Bridge', icon: Ruler },
    { name: 'Wide RCC Roads', icon: Construction }
];

/** Get icon component for an amenity name (for use on details page). */
export const getAmenityIcon = (name) => {
    const found = AMENITIES_LIST.find((a) => a.name === name);
    return found ? found.icon : null;
};
